import { useAppContext } from '../../../context/siteMapContext'
import useIsActive from '../../../hooks/useIsActive'

const Marker: React.FC<{
  id: string
  activeItemId: string
  handleClick: (id: string) => void
}> = ({ id, activeItemId, handleClick }) => {
  const { highContrastOn } = useAppContext();
  const isActive = useIsActive(id, activeItemId)
  return (
    <div
      onClick={() => handleClick(id)}
      className='rounded-full w-8 h-8 cursor-pointer'
      style={{
        backgroundColor: isActive ? (highContrastOn ? '#ffff00' : '#b6182d') : '#fff',
      }}
    />
  )
}

export default Marker
